export const pointerSize = 12;
export const bg = 'darkBlue.18';
export const borderRaduis = 1;
export const boxShadow = 2;
export const pointerPlacement = {
    top: {
        top: 'auto',
        bottom: `-${pointerSize / 2}px`,
        left: '50%',
        right: 'auto',
        translate: '-50%, 0'
    },
    bottom: {
        top: `-${pointerSize / 2}px`,
        bottom: 'auto',
        left: '50%',
        right: 'auto',
        translate: '-50%, 0'
    },
    left: {
        top: `50%`,
        bottom: 'auto',
        left: 'auto',
        right: '-4px',
        translate: '-50%, -50%'
    },
    right: {
        top: `50%`,
        bottom: 'auto',
        left: '2px',
        right: 'auto',
        translate: '0, -50%'
    }
};
